import { ChangeEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import SecSeperator from './ui/SecSeperator';
import { getCountryImage, getTopLevelDomain } from '../utils/translation';
import { COUNTRY_TOP_LEVEL_DOMAIN } from '../constants';

const Hero = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation(['hero']);
    const topLevelDomain = getTopLevelDomain();

    const [searchText, setSearchText] = useState('');
    const [backgroundImage, setBackgroundImage] = useState(getBackgroundImageByDomain());


    useEffect(() => {
        setBackgroundImage(getBackgroundImageByDomain());
    }, []);

    function getBackgroundImageByDomain() {
        const isTab = window.innerWidth >= 425 && window.innerWidth <= 768;
        const isMobile = window.innerWidth <= 425;
        switch (topLevelDomain) {
            case COUNTRY_TOP_LEVEL_DOMAIN.ma:
                return isMobile ? '/images/hero/hero_image_1_sm.webp' : isTab ? '/images/hero/hero_image_1_md.webp' : '/images/hero/hero_image_1.webp';
            default:
                return isMobile ? '/images/hero/hero_image_sm.webp' : isTab ? '/images/hero/hero_image_md.webp' :  '/images/hero/hero_image.webp';
        }
    }

    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
    };

    const handleSearch = () => {
        navigate(
            `${t('/buy-cars', { ns: 'routes' })}${
                !!searchText ? `?search=${searchText}` : ''
            }`
        );
    };

    return (
        <div 
            className="hero-section" 
            style={{
                backgroundImage: `url(${backgroundImage})`
            }}
        >
            <div className="hero-overlay"></div>
            <div className="padding">
                <div className="hero-content">
                    <SecSeperator
                        borderColor="#fff"
                        backgroundColor="#fff"
                        className="hero"
                    />
                    <div
                        className={
                            i18n.language === 'en'
                                ? 'hero-text-container'
                                : 'hero-text-container fre'
                        }
                    >
                        <h1
                            className="hero-text"
                            dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                        >
                            {t('searchBarTitle')}
                            <span style={{ marginLeft: '24px' }}>
                                <img
                                    src={getCountryImage().src}
                                    alt={getCountryImage().alt}
                                    style={{
                                        width: '65px',
                                        height: '65px'
                                    }}
                                    loading='lazy'
                                />
                            </span>
                        </h1>{' '}
                    </div>
                    <form className="search-form">
                        <input
                            type="text"
                            className="search-input"
                            placeholder={t('searchBarPlaceholder')}
                            onChange={handleSearchChange}
                        />{' '}
                        <button
                            className="search-button text-uppercase"
                            onClick={handleSearch}
                        >
                            <span className={"default-bold-font"} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                                {t('common:search')}
                            </span>
                        </button>
                    </form>
                    <div className="sell-now">
                        <p dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                            {t('willingToSellYourUsedCar')}
                        </p>
                        <button
                            className="sell-now-btn"
                            onClick={() =>
                                navigate(t('/sell-car', { ns: 'routes' }))
                            }
                        >
                            <span className={"default-font text-uppercase sell-text"} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
                                {t('common:sellCar')}
                            </span>
                            <h2 className={'plus-sign'}>+</h2>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Hero;
